import type { ReactNode } from 'react'

import { proseDatePattern } from '@/utils/dateHelpers'

/**
 * Gives the dates in an obligation description their own weight.
 *
 * A bare month is left alone: "renews every March" is a cadence, not something
 * a reader can act on. Text with no date comes back unchanged.
 */
export const emphasizeDates = (text: string | null | undefined): ReactNode => {
  if (!text) return text ?? null
  const pattern = proseDatePattern()
  const matches = text.match(pattern)
  if (!matches) return text
  // `<strong>`, not the `Text` atom: `Text` renders a `<p>`, which cannot nest.
  return text.split(pattern).flatMap((part, i) => [
    part,
    ...(i < matches.length
      ? [
          <strong key={`date-${i}`} className="font-semibold text-neutral-900">
            {matches[i]}
          </strong>,
        ]
      : []),
  ])
}
